import { render, staticRenderFns } from "./SuburbAutoComplete.vue?vue&type=template&id=d218674a&"
import script from "./SuburbAutoComplete.vue?vue&type=script&lang=js&"
export * from "./SuburbAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports